// extracted by mini-css-extract-plugin
export default {"content":"ingredient-details_content__Bj3Vw","image":"ingredient-details_image__C3eCe","list":"ingredient-details_list__P-SZX","text":"ingredient-details_text__PD5Nd"};